import React from 'react';
import { Div, Heading } from '@kizi/core-components';

interface Section {
  content: React.ReactNode;
}

interface SectionsProps {
  title?: string;
  sections: Section[];
}

export const Sections = ({ title, sections }: SectionsProps) => {
  return (
    <Div variant="sections">
      {title && <Heading variant="H4">{title}</Heading>}
      {sections.map((section, index) => (
        <Div key={index}>{section.content}</Div>
      ))}
    </Div>
  );
};
